import React, { useState } from 'react';
import './HeaderDash.css';
import ButonScreen from '../ButonScreen/ButonScreen';
import InputSearch from '../InputSearch/InputSearch';
import InfoUser from '../InfoUser/InfoUser';
import ButonInstallAppNav from '../ButonInstallAppNav/ButonInstallAppNav'
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser } from '@fortawesome/free-solid-svg-icons';
export default function () {


    return (
        <div className={`HeaderDashContain`}>
            <InputSearch />

            <div className='deFlexHeader'>
               
                 <Anchor to={'/'} className='link'>
                    <FontAwesomeIcon icon={faUser} /> Modo Cliente
                </Anchor>
                {/* <ButonInstallAppNav /> */}
                <Anchor to={'/dashboard'} className='link'>
                    <FontAwesomeIcon icon={faHome} /> Inicio
                </Anchor>
                
               
                
                {/* <InfoUser /> */}
            </div>


        </div>
    );
}
